import React, { useState, useEffect, ChangeEvent } from 'react';
import {
  Box,
  Button,
  Typography,
  Paper,
  TextField,
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
  Stack,
  Grid,
  Snackbar,
  Alert,
  InputAdornment,
  CircularProgress,
  Container,
  DialogTitle,
  Avatar,
  Tabs,
  Tab,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  Checkbox,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  TableSortLabel,
} from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Design, designApi, prepareDesignForAPI } from '../api/design';
import { Pagination, PaginationItem } from '@mui/material';
import { useMemo, useRef } from 'react';
import api from '../services/api';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewListIcon from '@mui/icons-material/ViewList';
// import CloseIcon from '@mui/icons-material/Close';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { usePermissions } from '../hooks/usePermissions';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import DesignPreviewDialog from '../components/DesignPreviewDialog';
import instance from '../utils/axios';
import { DesignMaterialContent } from './DesignMaterialPage';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import useMediaQuery from '@mui/material/useMediaQuery';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import WorkIcon from '@mui/icons-material/Work';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import Drawer from '@mui/material/Drawer';
import DesignChatThread from '../components/DesignChatThread';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Autocomplete from '@mui/material/Autocomplete';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { materialsApi } from '../api/materials';
import designMaterialsApi, { CreateDesignMaterialDTO } from '../api/designMaterials';
import { GARMENT_PARTS } from '../constants/garmentConstants';
import { designBomApi, DesignBOMItem, CreateBOMItemDTO } from '../api/designBom';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LinearProgress from '@mui/material/LinearProgress';

const BOM_MATERIAL_TYPES = ['FABRIC', 'LACE', 'BUTTON', 'SEMI_FINISHED'];
const BOM_GARMENT_PARTS = ['TOP', 'BOTTOM', 'DUPATTA', 'JACKET', 'ALL'];
const BOM_UOMS = ['METER', 'PCS', 'YARD', 'KG', 'SET'];
const emptyBomItem: CreateBOMItemDTO = {
  material_type: 'FABRIC',
  material_name: '',
  material_id: null,
  garment_part: 'TOP',
  consumption_per_piece: 0,
  uom: 'METER',
  wastage_pct: 5,
  estimated_rate: null,
  notes: '',
  is_optional: false,
};

// Create a dialog component for adding/editing designs
const DesignFormDialog: React.FC<{
  open: boolean;
  designId: number | null;
  onClose: () => void;
  onSave: () => void;
  onDelete?: (id: number) => void;
  initialDuplicateData?: Partial<Design> | null;
}> = ({ open, designId, onClose, onSave, onDelete, initialDuplicateData }) => {
  const [formData, setFormData] = useState<Partial<Design>>({
    design_no: '',
    name: '',
    description: '',
    product_type: 'KURTI',
    approval_status: 'HOLD',
    design_date: new Date().toISOString().split('T')[0],
    
    
    
    
    notes: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const [image2File, setImage2File] = useState<File | null>(null);
  const [image2Preview, setImage2Preview] = useState<string | null>(null);
  const [image3File, setImage3File] = useState<File | null>(null);
  const [image3Preview, setImage3Preview] = useState<string | null>(null);
  const [image4File, setImage4File] = useState<File | null>(null);
  const [image4Preview, setImage4Preview] = useState<string | null>(null);
  
  // Material allocation state
  const [availableMaterials, setAvailableMaterials] = useState<any[]>([]);
  const [existingAllocations, setExistingAllocations] = useState<any[]>([]);
  const [materialAllocations, setMaterialAllocations] = useState<Array<{
    id?: number;
    material_id: number;
    garment_part: string;
    is_sample: boolean;
    allocated_qty: number;
    selectedMaterial: any;
  }>>([]);
  const [loadingMaterials, setLoadingMaterials] = useState(false);
  const [allocationError, setAllocationError] = useState<string | null>(null);

  // BOM state
  const [bomItems, setBomItems] = useState<DesignBOMItem[]>([]);
  const [bomLoading, setBomLoading] = useState(false);
  const [bomDialogOpen, setBomDialogOpen] = useState(false);
  const [bomEditingItem, setBomEditingItem] = useState<DesignBOMItem | null>(null);
  const [bomFormRows, setBomFormRows] = useState<CreateBOMItemDTO[]>([{ ...emptyBomItem }]);
  const [bomSaving, setBomSaving] = useState(false);

  
  // Fetch available materials when dialog opens
  useEffect(() => {
    if (open) {
      const fetchMaterials = async () => {
        try {
          setLoadingMaterials(true);
          const response = await materialsApi.getAvailable();
          let materialsData = [];
          if (response && response.data) {
            materialsData = response.data;
          } else if (Array.isArray(response)) {
            materialsData = response;
          }
          setAvailableMaterials(materialsData);
        } catch (err) {
          console.error('Error fetching materials:', err);
        } finally {
          setLoadingMaterials(false);
        }
      };
      fetchMaterials();
    }
  }, [open]);

  // Fetch existing allocations when editing
  useEffect(() => {
    if (open && designId && formData.design_no) {
      const fetchAllocations = async () => {
        try {
          const allocations = await designMaterialsApi.getByDesignNo(formData.design_no!);
          setExistingAllocations(allocations || []);
          // Convert to our local format
          const localAllocations = (allocations || []).map((alloc: any) => ({
            id: alloc.id,
            material_id: alloc.material_id,
            garment_part: alloc.garment_part,
            is_sample: alloc.is_sample,
            allocated_qty: alloc.allocated_qty,
            selectedMaterial: alloc.material || null
          }));
          setMaterialAllocations(localAllocations);
        } catch (err) {
          console.error('Error fetching allocations:', err);
        }
      };
      fetchAllocations();
    } else if (open && !designId) {
      // Reset allocations for new design
      setExistingAllocations([]);
      setMaterialAllocations([]);
    }
  }, [open, designId, formData.design_no]);

  // Fetch BOM items when editing an existing design
  const fetchBomItems = async (designNo: string) => {
    setBomLoading(true);
    try {
      const data = await designBomApi.getByDesign(designNo);
      setBomItems(data.bomItems || []);
    } catch (error: any) {
      if (error.response?.status !== 404) {
        console.error('Failed to fetch BOM items:', error);
      }
      setBomItems([]);
    } finally {
      setBomLoading(false);
    }
  };

  useEffect(() => {
    if (open && designId && formData.design_no) {
      fetchBomItems(formData.design_no);
    } else if (open && !designId) {
      setBomItems([]);
    }
  }, [open, designId, formData.design_no]);

  // BOM handlers
  const handleBomAdd = () => {
    setBomEditingItem(null);
    setBomFormRows([{ ...emptyBomItem }]);
    setBomDialogOpen(true);
  };

  const handleBomEdit = (item: DesignBOMItem) => {
    setBomEditingItem(item);
    setBomFormRows([{
      material_type: item.material_type,
      material_name: item.material_name,
      material_id: item.material_id,
      garment_part: item.garment_part,
      consumption_per_piece: item.consumption_per_piece,
      uom: item.uom,
      wastage_pct: item.wastage_pct,
      estimated_rate: item.estimated_rate,
      notes: item.notes || '',
      is_optional: item.is_optional,
    }]);
    setBomDialogOpen(true);
  };

  const updateBomRow = (index: number, field: keyof CreateBOMItemDTO, value: any) => {
    setBomFormRows(prev => prev.map((row, i) => i === index ? { ...row, [field]: value } : row));
  };

  const addBomRow = () => {
    setBomFormRows(prev => [...prev, { ...emptyBomItem }]);
  };

  const removeBomRow = (index: number) => {
    setBomFormRows(prev => prev.filter((_, i) => i !== index));
  };

  const handleBomSave = async () => {
    if (!formData.design_no) return;
    // Filter rows that have at least material_name filled
    const validRows = bomFormRows.filter(r => r.material_name.trim() && r.consumption_per_piece > 0);
    if (validRows.length === 0) return;

    setBomSaving(true);
    try {
      if (bomEditingItem) {
        // Edit mode: single item update
        await designBomApi.updateItem(formData.design_no, bomEditingItem.id, validRows[0]);
      } else {
        // Add mode: save all valid rows
        for (const row of validRows) {
          await designBomApi.addItem(formData.design_no, row);
        }
      }
      setBomDialogOpen(false);
      fetchBomItems(formData.design_no);
    } catch (error: any) {
      console.error('Failed to save BOM item:', error);
      setError(error.response?.data?.error || 'Failed to save BOM item');
    } finally {
      setBomSaving(false);
    }
  };

  const handleBomDelete = async (id: number) => {
    if (!formData.design_no || !window.confirm('Delete this BOM item?')) return;
    try {
      await designBomApi.deleteItem(formData.design_no, id);
      fetchBomItems(formData.design_no);
    } catch (error: any) {
      console.error('Failed to delete BOM item:', error);
      setError(error.response?.data?.error || 'Failed to delete BOM item');
    }
  };

  const handleBomGenerate = async () => {
    if (!formData.design_no) return;
    try {
      await designBomApi.generateFromDesign(formData.design_no);
      fetchBomItems(formData.design_no);
    } catch (error: any) {
      console.error('Failed to generate BOM:', error);
      setError(error.response?.data?.error || 'Failed to generate BOM from design');
    }
  };

  const bomEstimatedCost = bomItems.reduce((sum, item) => {
    return sum + (item.consumption_per_piece * (item.estimated_rate || 0));
  }, 0);

  const isBomFinalized = bomItems.some(b => b.finalized_at);

  useEffect(() => {
    if (initialDuplicateData && open) {
      // Duplicating a design - use provided data but clear design_no
      setFormData({
        ...initialDuplicateData,
        design_no: '', // Clear for user to enter new design number
      });
      
      // Image 1 is cleared for new upload, Image 2 has the original main image
      setImagePreview(null); // Clear main image preview for new upload
      setImageFile(null);
      if (initialDuplicateData.image2_url) {
        setImage2Preview(initialDuplicateData.image2_url);
      } else {
        setImage2Preview(null);
      }
      if (initialDuplicateData.image3_url) {
        setImage3Preview(initialDuplicateData.image3_url);
      } else {
        setImage3Preview(null);
      }
      if (initialDuplicateData.image4_url) {
        setImage4Preview(initialDuplicateData.image4_url);
      } else {
        setImage4Preview(null);
      }
    } else if (designId && open) {
      setLoading(true);
      designApi.getById(designId)
        .then(response => {
          const design = response.data;
          
          // Log the design data received from the API
          console.log('Design data from API:', JSON.stringify(design, null, 2));
          
          // Ensure required fields have proper string values
          const enhancedDesign = {
            ...design,
            design_no: design.design_no || '',
            product_type: design.product_type || 'KURTI'
          };
          
          console.log('Enhanced design data:', JSON.stringify(enhancedDesign, null, 2));
          setFormData(enhancedDesign);
          
          if (design.image_url) {
            setImagePreview(design.image_url);
          }
          if (design.image2_url) {
            setImage2Preview(design.image2_url);
          }
          if (design.image3_url) {
            setImage3Preview(design.image3_url);
          }
          if (design.image4_url) {
            setImage4Preview(design.image4_url);
          }
        })
        .catch(err => {
          setError(err.response?.data?.error || 'Failed to load design');
        })
        .finally(() => {
          setLoading(false);
        });
    } else if (open) {
      // Reset form for new design
      setFormData({
        design_no: '',
        name: '',
        description: '',
        product_type: 'KURTI',
        approval_status: 'HOLD',
        design_date: new Date().toISOString().split('T')[0],
        
        
        
        
        notes: '',
      });
      setImagePreview(null);
      setImageFile(null);
      setImage2Preview(null);
      setImage2File(null);
      setImage3Preview(null);
      setImage3File(null);
      setImage4Preview(null);
      setImage4File(null);
    }
  }, [designId, open, initialDuplicateData]);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    
    // Log the input change for debugging
    console.log(`Input change - Field: ${name}, Value: ${value}, Type: ${type}`);
    
    let parsedValue: any = value;
    
    // Special handling for numeric fields (except design_no which should be string)
    if (name !== 'design_no' && 
        (name === 'lot_number' || name === 'mrp' || name === 'cost' || 
         name === 'quantity_ready' || name === 'order_quantity' || name === 'net_quantity')) {
      parsedValue = value === '' ? '' : parseFloat(value);
    }
    
    // Ensure design_no and product_type are always strings
    if (name === 'design_no' || name === 'product_type') {
      parsedValue = String(value);
    }
    
    setFormData(prev => ({
      ...prev,
      [name]: parsedValue
    }));
  };

  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>, imageNumber: number) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const reader = new FileReader();
      
      reader.onload = (event) => {
        if (event.target?.result) {
          const preview = event.target.result as string;
          
          switch (imageNumber) {
            case 1:
              setImageFile(file);
              setImagePreview(preview);
              break;
            case 2:
              setImage2File(file);
              setImage2Preview(preview);
              break;
            case 3:
              setImage3File(file);
              setImage3Preview(preview);
              break;
            case 4:
              setImage4File(file);
              setImage4Preview(preview);
              break;
          }
        }
      };
      
      reader.readAsDataURL(file);
    }
  };
  
  // Material allocation handlers
  const handleAddMaterialRow = () => {
    setMaterialAllocations([
      ...materialAllocations,
      {
        material_id: 0,
        garment_part: '',
        is_sample: false,
        allocated_qty: 0,
        selectedMaterial: null
      }
    ]);
  };

  const handleRemoveMaterialRow = (index: number) => {
    const updatedAllocations = [...materialAllocations];
    updatedAllocations.splice(index, 1);
    setMaterialAllocations(updatedAllocations);
  };

  const handleMaterialAllocationChange = (index: number, field: string, value: any) => {
    const updatedAllocations = [...materialAllocations];
    updatedAllocations[index] = {
      ...updatedAllocations[index],
      [field]: value
    };
    setMaterialAllocations(updatedAllocations);
  };

  const handleMaterialSelect = (index: number, material: any) => {
    const updatedAllocations = [...materialAllocations];
    updatedAllocations[index] = {
      ...updatedAllocations[index],
      material_id: material?.id || 0,
      selectedMaterial: material
    };
    setMaterialAllocations(updatedAllocations);
  };

  const handleDeleteAllocation = async (allocationId: number, index: number) => {
    try {
      await designMaterialsApi.delete(allocationId);
      const updatedAllocations = [...materialAllocations];
      updatedAllocations.splice(index, 1);
      setMaterialAllocations(updatedAllocations);
      setExistingAllocations(existingAllocations.filter(a => a.id !== allocationId));
    } catch (err: any) {
      setAllocationError(err.message || 'Failed to delete allocation');
    }
  };

  const handleDeleteImage = (imageNumber: number) => {
    switch (imageNumber) {
      case 1:
        setImageFile(null);
        setImagePreview(null);
        setFormData(prev => ({ ...prev, image_url: null }));
        break;
      case 2:
        setImage2File(null);
        setImage2Preview(null);
        setFormData(prev => ({ ...prev, image2_url: null }));
        break;
      case 3:
        setImage3File(null);
        setImage3Preview(null);
        setFormData(prev => ({ ...prev, image3_url: null }));
        break;
      case 4:
        setImage4File(null);
        setImage4Preview(null);
        setFormData(prev => ({ ...prev, image4_url: null }));
        break;
    }
  };

  const handleSubmit = async () => {
    try {
      // Log the form data being submitted
      console.log('Submitting design form data:', JSON.stringify(formData, null, 2));
      
      // Validate required fields with additional logging
      if (!formData.design_no || formData.design_no.trim() === '') {
        console.error('Missing design_no:', formData.design_no);
        setError('Design number is required');
        return;
      }
      
      if (!formData.product_type || formData.product_type.trim() === '') {
        console.error('Missing product_type:', formData.product_type);
        setError('Product type is required');
        return;
      }
      
      console.log('Validation passed, preparing design data for API');
      // Continue with submission
      setLoading(true);
      setError('');
      const designData = prepareDesignForAPI(formData);
      console.log('Prepared data for API:', JSON.stringify(designData, null, 2));
      
      // Upload images if selected
      const uploadImage = async (file: File | null) => {
        if (!file) return null;
        
        const uploadFormData = new FormData();
        uploadFormData.append('file', file);
        
        try {
          console.log('Uploading image:', file.name);
          // Use our axios instance instead of fetch
          const response = await instance.post('/upload', uploadFormData, {
            headers: {
              // Let axios set the content-type with boundary
              'Content-Type': undefined
            }
          });
          
          console.log('Image upload successful:', response.data);
          return response.data.url;
        } catch (error: any) {
          console.error('Image upload failed:', error);
          throw new Error(`Failed to upload image ${file.name}: ${error.message || 'Unknown error'}`);
        }
      };
      
      try {
        // Only upload images that have changed (new files selected)
        if (imageFile) {
          designData.image_url = await uploadImage(imageFile);
        }
        
        if (image2File) {
          designData.image2_url = await uploadImage(image2File);
        }
        
        if (image3File) {
          designData.image3_url = await uploadImage(image3File);
        }
        
        if (image4File) {
          designData.image4_url = await uploadImage(image4File);
        }
        
      } catch (err) {
        console.error('Image upload error:', err);
        throw new Error('Failed to upload one or more images');
      }

      // Create or update design
      let savedDesignNo = formData.design_no!;
      if (designId) {
        await designApi.update(designId, designData);
      } else {
        const createResponse = await designApi.create(designData);
        // If new design was created, we'll use its design_no
        savedDesignNo = createResponse?.data?.design_no || formData.design_no!;
      }

      // Save modified existing material allocations
      const modifiedAllocations = materialAllocations.filter(a => {
        if (!a.id) return false;
        const original = existingAllocations.find(ea => ea.id === a.id);
        if (!original) return false;
        return a.allocated_qty !== original.allocated_qty ||
               a.garment_part !== original.garment_part ||
               a.is_sample !== original.is_sample;
      });
      if (modifiedAllocations.length > 0) {
        const updatePromises = modifiedAllocations.map(alloc =>
          designMaterialsApi.update(alloc.id!, {
            allocated_qty: alloc.allocated_qty,
            garment_part: alloc.garment_part || 'ALL',
            is_sample: alloc.is_sample
          })
        );
        await Promise.all(updatePromises);
      }

      // Save new material allocations (ones without an id)
      const newAllocations = materialAllocations.filter(a => !a.id && a.material_id > 0 && a.allocated_qty > 0);
      if (newAllocations.length > 0) {
        const promises = newAllocations.map(alloc =>
          designMaterialsApi.create({
            design_no: savedDesignNo,
            design_company_id: formData.company_id || 0,
            material_id: alloc.material_id,
            garment_part: alloc.garment_part || 'ALL',
            is_sample: alloc.is_sample,
            allocated_qty: alloc.allocated_qty
          })
        );
        await Promise.all(promises);
      }

      onSave();
    } catch (err: any) {
      console.error('Submit error:', err);
      setError(err.response?.data?.error || err.message || 'Failed to save design');
    } finally {
      setLoading(false);
    }
  };

  // Render an image upload section with preview and delete option
  const renderImageUpload = (
    imageNumber: number, 
    previewUrl: string | null, 
    label: string
  ) => {
    const inputId = `design-image${imageNumber}-upload`;
    
    return (
      <Grid item xs={12} sm={6} md={3}>
        <Typography variant="subtitle2" gutterBottom>
          {label}
        </Typography>
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1,
          mb: 2
        }}>
          <Box sx={{
            width: '100%',
            height: 150,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: '1px dashed #ccc',
            borderRadius: 1,
            overflow: 'hidden',
            position: 'relative',
            bgcolor: 'background.paper'
          }}>
            {previewUrl ? (
              <>
                <img
                  src={previewUrl}
                  alt={`Design Image ${imageNumber}`}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain'
                  }}
                />
                <IconButton 
                  size="small" 
                  sx={{
                    position: 'absolute', 
                    top: 5, 
                    right: 5,
                    bgcolor: 'background.paper',
                    '&:hover': {
                      bgcolor: 'error.light',
                      color: 'white'
                    }
                  }}
                  onClick={() => handleDeleteImage(imageNumber)}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </>
            ) : (
              <Typography color="text.secondary">
                No image
              </Typography>
            )}
          </Box>
          
          <input
            accept="image/*"
            id={inputId}
            type="file"
            onChange={(e) => handleFileSelect(e, imageNumber)}
            style={{ display: 'none' }}
          />
          <label htmlFor={inputId}>
            <Button
              variant="outlined"
              component="span"
              size="small"
              startIcon={<PhotoCameraIcon />}
            >
              {previewUrl ? 'Change' : 'Upload'}
            </Button>
          </label>
        </Box>
      </Grid>
    );
  };

  // CAD File Upload Component
  const CadFileUpload: React.FC<{
    label: string;
    fileUrl: string | null;
    onChange: (url: string | null) => void;
    disabled?: boolean;
  }> = ({ label, fileUrl, onChange, disabled = false }) => {
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [fileName, setFileName] = useState<string | null>(null);
    
    useEffect(() => {
      // Extract file name from URL if available
      if (fileUrl) {
        const urlParts = fileUrl.split('/');
        setFileName(urlParts[urlParts.length - 1]);
      } else {
        setFileName(null);
      }
    }, [fileUrl]);

    const handleFileSelect = async (e: React.ChangeEvent<HTMLInputElement>) => {
      if (disabled) return;
      
      const file = e.target.files?.[0];
      if (!file) return;
      
      setUploading(true);
      setError(null);
      
      try {
        // Create form data
        const formData = new FormData();
        formData.append('file', file);
        
        // Specify the module as 'designs' to store in designs folder
        const params = { module: 'designs' };
        const queryString = new URLSearchParams(params).toString();
        
        // Upload the file to Google Cloud Storage
        const response = await instance.post(`/upload?${queryString}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        
        if (response.data && response.data.url) {
          onChange(response.data.url);
          setFileName(file.name);
        } else {
          throw new Error('No URL returned from server');
        }
      } catch (err: any) {
        console.error('Error uploading CAD file:', err);
        setError(err.response?.data?.error || 'Failed to upload file');
      } finally {
        setUploading(false);
        
        // Reset input value so the same file can be selected again
        e.target.value = '';
      }
    };
    
    const handleRemoveFile = () => {
      if (disabled) return;
      onChange(null);
      setFileName(null);
    };
    
    return (
      <Box sx={{ width: '100%', mb: 1 }}>
        <Typography variant="body2" gutterBottom>{label}</Typography>
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center',
          gap: 1,
          flexWrap: 'wrap'
        }}>
          <input
            type="file"
            accept=".pdf,.dwg,.dxf,.ai,.psd,.cdr,.eps,.svg"
            onChange={handleFileSelect}
            style={{ display: 'none' }}
            id={`cad-file-input-${label}`}
            disabled={disabled || uploading}
          />
          <Button
            variant="outlined"
            component="label"
            htmlFor={`cad-file-input-${label}`}
            startIcon={<CloudUploadIcon />}
            disabled={disabled || uploading}
            size="small"
            sx={{ flexShrink: 0 }}
          >
            {uploading ? 'Uploading...' : 'Upload File'}
          </Button>
          
          {fileUrl && (
            <>
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 0.5,
                flex: 1,
                minWidth: 0,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                p: 0.5
              }}>
                <InsertDriveFileIcon fontSize="small" color="primary" />
                <Typography variant="body2" noWrap sx={{ flex: 1 }}>
                  {fileName || 'Uploaded file'}
                </Typography>
                <IconButton 
                  size="small" 
                  href={fileUrl} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  title="Download file"
                >
                  <FileDownloadIcon fontSize="small" />
                </IconButton>
                <IconButton 
                  size="small" 
                  onClick={handleRemoveFile} 
                  disabled={disabled}
                  title="Remove file"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
            </>
          )}
          
          {error && (
            <Typography variant="caption" color="error">
              {error}
            </Typography>
          )}
        </Box>
      </Box>
    );
  };

  return (
    <>
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg" 
      fullWidth
      PaperProps={{
        sx: { maxHeight: '90vh' }
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>{initialDuplicateData ? 'Duplicate Design' : (designId ? 'Edit Design' : 'Create New Design')}</span>
        {designId && !initialDuplicateData && (
          <Button
            size="small"
            variant="outlined"
            onClick={() => {
              // Trigger duplicate mode by calling onClose and then re-opening with duplicate data
              // We'll use a callback to pass formData to parent
              if ((window as any).__handleDuplicateDesign) {
                (window as any).__handleDuplicateDesign(formData);
              }
            }}
            sx={{ ml: 2 }}
          >
            Duplicate
          </Button>
        )}
      </DialogTitle>
      <DialogContent dividers>
        {loading && !formData ? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
          </Box>
        ) : (
          <Box component="form" sx={{ mt: 2 }}>
            {error && (
              <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
                {error}
              </Alert>
            )}
            
            <Paper elevation={0} sx={{ p: 2, mb: 3, bgcolor: 'background.default' }}>
              <Typography variant="h6" gutterBottom>Basic Information</Typography>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    required
                    fullWidth
                    label="Design Number"
                    name="design_no"
                    value={formData.design_no || ''}
                    onChange={handleInputChange}
                  />
                </Grid>
                
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    select
                    required
                    fullWidth
                    label="Product Type"
                    name="product_type"
                    value={formData.product_type || 'KURTI'}
                    onChange={handleInputChange}
                    SelectProps={{
                      native: true
                    }}
                  >
                    <option value="TOP">Top</option>
                    <option value="KURTI">Kurti</option>
                    <option value="DRESS">Dress</option>
                    <option value="SUIT">Salwar Suit</option>
                    <option value="TOPBOTTOMSET">Top Bottom Set</option>
                  </TextField>
                </Grid>
                
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    fullWidth
                    label="Designer Name"
                    name="name"
                    value={formData.name || ''}
                    onChange={handleInputChange}
                  />
                </Grid>
                
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    type="date"
                    fullWidth
                    label="Design Date"
                    name="design_date"
                    value={formData.design_date || ''}
                    onChange={handleInputChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                
                {/* Description field hidden for now
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={2}
                    label="Description"
                    name="description"
                    value={formData.description || ''}
                    onChange={handleInputChange}
                  />
                </Grid>
                */}
              </Grid>
            </Paper>
            
            {/* Images Section */}
            <Paper elevation={0} sx={{ p: 2, mb: 3, bgcolor: 'background.default' }}>
              <Typography variant="h6" gutterBottom>Images</Typography>
              <Grid container spacing={3}>
                {renderImageUpload(1, imagePreview, "Main Image")}
                {renderImageUpload(2, image2Preview, "Image 2")}
                {renderImageUpload(3, image3Preview, "Image 3")}
                {renderImageUpload(4, image4Preview, "Image 4")}
              </Grid>
            </Paper>

            {/* Material Allocation Section */}
            <Paper elevation={0} sx={{ p: 2, mb: 3, bgcolor: 'background.default' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6">Materials Allocated</Typography>
                <Button
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={handleAddMaterialRow}
                  disabled={loadingMaterials}
                >
                  Add Material
                </Button>
              </Box>
              
              {allocationError && (
                <Alert severity="error" sx={{ mb: 2 }} onClose={() => setAllocationError(null)}>
                  {allocationError}
                </Alert>
              )}
              
              {materialAllocations.length === 0 ? (
                <Typography color="text.secondary" sx={{ textAlign: 'center', py: 2 }}>
                  No materials allocated yet. Click "Add Material" to allocate materials to this design.
                </Typography>
              ) : (
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ minWidth: 200 }}>Material</TableCell>
                        <TableCell sx={{ width: 120 }}>Part</TableCell>
                        <TableCell sx={{ width: 100 }}>Qty</TableCell>
                        <TableCell sx={{ width: 80, textAlign: 'center' }}>Sample</TableCell>
                        <TableCell sx={{ width: 60 }}></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {materialAllocations.map((allocation, index) => (
                        <TableRow key={allocation.id || `new-${index}`}>
                          <TableCell>
                            <Autocomplete
                              size="small"
                              options={availableMaterials}
                              getOptionLabel={(option) => {
                                if (!option) return '';
                                return `${option.material_code || ''} - ${option.material_type || ''} (${option.available_qty || 0} ${option.uom || ''})`;
                              }}
                              value={allocation.selectedMaterial}
                              onChange={(_, newValue) => handleMaterialSelect(index, newValue)}
                              renderOption={(props, option) => (
                                <li {...props}>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {option.image_url && (
                                      <Box
                                        component="img"
                                        src={option.image_url}
                                        sx={{ width: 30, height: 30, objectFit: 'cover', borderRadius: 0.5 }}
                                      />
                                    )}
                                    <Box>
                                      <Typography variant="body2">{option.material_code}</Typography>
                                      <Typography variant="caption" color="text.secondary">
                                        {option.material_type} ({option.available_qty} {option.uom})
                                      </Typography>
                                    </Box>
                                  </Box>
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Select material"
                                  size="small"
                                />
                              )}
                              disabled={!!allocation.id}
                              loading={loadingMaterials}
                            />
                          </TableCell>
                          <TableCell>
                            <Select
                              size="small"
                              fullWidth
                              value={allocation.garment_part || ''}
                              onChange={(e) => handleMaterialAllocationChange(index, 'garment_part', e.target.value)}
                            >
                              <MenuItem value="">Select</MenuItem>
                              {GARMENT_PARTS.map((part) => (
                                <MenuItem key={part} value={part}>{part}</MenuItem>
                              ))}
                              <MenuItem value="ALL">ALL</MenuItem>
                            </Select>
                          </TableCell>
                          <TableCell>
                            <TextField
                              size="small"
                              type="number"
                              value={allocation.allocated_qty || ''}
                              onChange={(e) => handleMaterialAllocationChange(index, 'allocated_qty', parseFloat(e.target.value) || 0)}
                              inputProps={{ min: 0, step: 0.01 }}
                              sx={{ width: 80 }}
                            />
                          </TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>
                            <input
                              type="checkbox"
                              checked={allocation.is_sample}
                              onChange={(e) => handleMaterialAllocationChange(index, 'is_sample', e.target.checked)}
                            />
                          </TableCell>
                          <TableCell>
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => {
                                if (allocation.id) {
                                  handleDeleteAllocation(allocation.id, index);
                                } else {
                                  handleRemoveMaterialRow(index);
                                }
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
              
              {materialAllocations.length > 0 && (
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                  * All changes to allocations will be saved when you save the design.
                </Typography>
              )}
            </Paper>

            {/* CAD Files */}
            <Paper elevation={0} sx={{ p: 2, mb: 3, bgcolor: 'background.default' }}>
              <Typography variant="h6" gutterBottom>CAD Files</Typography>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <CadFileUpload
                    label="CAD File 1"
                    fileUrl={formData.cad_file_1 || null}
                    onChange={(url) => setFormData({...formData, cad_file_1: url})}
                    disabled={loading}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CadFileUpload
                    label="CAD File 2"
                    fileUrl={formData.cad_file_2 || null}
                    onChange={(url) => setFormData({...formData, cad_file_2: url})}
                    disabled={loading}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CadFileUpload
                    label="CAD File 3"
                    fileUrl={formData.cad_file_3 || null}
                    onChange={(url) => setFormData({...formData, cad_file_3: url})}
                    disabled={loading}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CadFileUpload
                    label="CAD File 4"
                    fileUrl={formData.cad_file_4 || null}
                    onChange={(url) => setFormData({...formData, cad_file_4: url})}
                    disabled={loading}
                  />
                </Grid>
              </Grid>
            </Paper>
            
            {/* Bill of Materials */}
            <Paper elevation={0} sx={{ p: 2, mb: 3, bgcolor: 'background.default' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography variant="h6">Bill of Materials</Typography>
                  {bomItems.length > 0 && (
                    <Chip label={`${bomItems.length} items`} size="small" />
                  )}
                  {isBomFinalized && (
                    <Chip label="Finalized" color="success" size="small" icon={<CheckCircleIcon />} />
                  )}
                </Box>
                {designId && formData.design_no && (
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    {bomItems.length === 0 && (
                      <Button size="small" variant="outlined" startIcon={<AutoFixHighIcon />} onClick={handleBomGenerate}>
                        Auto-Generate
                      </Button>
                    )}
                    {!isBomFinalized && (
                      <Button size="small" variant="outlined" startIcon={<AddIcon />} onClick={handleBomAdd}>
                        Add Item
                      </Button>
                    )}
                  </Box>
                )}
              </Box>

              {!designId && (
                <Typography variant="body2" color="text.secondary">
                  Save the design first, then add BOM items.
                </Typography>
              )}

              {designId && bomLoading && <LinearProgress sx={{ mb: 1 }} />}

              {designId && !bomLoading && bomItems.length === 0 && formData.design_no && (
                <Typography variant="body2" color="text.secondary">
                  No BOM items yet. Click "Auto-Generate" to create from old design fields, or "Add Item" to add manually.
                </Typography>
              )}

              {bomItems.length > 0 && (
                <>
                  <TableContainer>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Material</TableCell>
                          <TableCell>Type</TableCell>
                          <TableCell>Part</TableCell>
                          <TableCell align="right">Per Pc</TableCell>
                          <TableCell>UOM</TableCell>
                          <TableCell align="right">Wastage%</TableCell>
                          <TableCell align="right">Rate</TableCell>
                          {!isBomFinalized && <TableCell align="center">Actions</TableCell>}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {bomItems.map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>
                              <Typography variant="body2" fontWeight={500}>{item.material_name}</Typography>
                              {item.notes && <Typography variant="caption" color="text.secondary" display="block">{item.notes}</Typography>}
                            </TableCell>
                            <TableCell><Chip label={item.material_type} size="small" variant="outlined" /></TableCell>
                            <TableCell>{item.garment_part}</TableCell>
                            <TableCell align="right">{item.consumption_per_piece}</TableCell>
                            <TableCell>{item.uom}</TableCell>
                            <TableCell align="right">{item.wastage_pct}%</TableCell>
                            <TableCell align="right">{item.estimated_rate ? `₹${item.estimated_rate}` : '-'}</TableCell>
                            {!isBomFinalized && (
                              <TableCell align="center">
                                <IconButton size="small" onClick={() => handleBomEdit(item)}><EditIcon fontSize="small" /></IconButton>
                                <IconButton size="small" color="error" onClick={() => handleBomDelete(item.id)}><DeleteIcon fontSize="small" /></IconButton>
                              </TableCell>
                            )}
                          </TableRow>
                        ))}
                        {bomEstimatedCost > 0 && (
                          <TableRow>
                            <TableCell colSpan={6} align="right"><Typography variant="subtitle2">Estimated BOM Cost</Typography></TableCell>
                            <TableCell align="right"><Typography variant="subtitle2" color="primary">₹{bomEstimatedCost.toFixed(2)}</Typography></TableCell>
                            {!isBomFinalized && <TableCell />}
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              )}
            </Paper>

            {/* Additional Info */}
            <Paper elevation={0} sx={{ p: 2, mb: 3, bgcolor: 'background.default' }}>
              <Typography variant="h6" gutterBottom>Additional Information</Typography>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    label="Approval Status"
                    name="approval_status"
                    value={formData.approval_status || 'HOLD'}
                    onChange={handleInputChange}
                    SelectProps={{
                      native: true
                    }}
                  >
                    <option value="APPROVED">Approved</option>
                    <option value="REJECTED">Rejected</option>
                    <option value="HOLD">Hold</option>
                    <option value="COMPLETE">Complete</option>
                  </TextField>
                </Grid>
                
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label="Notes"
                    name="notes"
                    value={formData.notes || ''}
                    onChange={handleInputChange}
                    placeholder="Additional notes about this design"
                  />
                </Grid>
              </Grid>
            </Paper>

          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Box>
          {designId && onDelete && (
            <Button 
              size="small" 
              color="error" 
              onClick={() => { onClose(); onDelete(designId); }}
              startIcon={<DeleteIcon />}
            >
              Delete
            </Button>
          )}
        </Box>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button 
            onClick={handleSubmit}
            variant="contained" 
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} /> : null}
          >
            {loading ? 'Saving...' : (designId ? 'Update' : 'Create')}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>

    {/* BOM Item Add/Edit Dialog — wide ERP style */}
    <Dialog open={bomDialogOpen} onClose={() => !bomSaving && setBomDialogOpen(false)} maxWidth={false} PaperProps={{ sx: { width: '95vw', maxWidth: 1200 } }}>
      <DialogTitle>{bomEditingItem ? 'Edit BOM Item' : `Add BOM Items (${bomFormRows.length})`}</DialogTitle>
      <DialogContent sx={{ px: 2, overflowX: 'auto' }}>
        <Box sx={{ minWidth: 900 }}>
          {/* Column headers */}
          <Box sx={{ display: 'flex', gap: 1, mb: 0.5, px: 0.5 }}>
            <Typography variant="caption" color="text.secondary" sx={{ width: 180, flexShrink: 0 }}>Material Name *</Typography>
            <Typography variant="caption" color="text.secondary" sx={{ width: 120, flexShrink: 0 }}>Type</Typography>
            <Typography variant="caption" color="text.secondary" sx={{ width: 110, flexShrink: 0 }}>Part</Typography>
            <Typography variant="caption" color="text.secondary" sx={{ width: 80, flexShrink: 0 }}>Per Pc *</Typography>
            <Typography variant="caption" color="text.secondary" sx={{ width: 90, flexShrink: 0 }}>UOM</Typography>
            <Typography variant="caption" color="text.secondary" sx={{ width: 80, flexShrink: 0 }}>Wastage %</Typography>
            <Typography variant="caption" color="text.secondary" sx={{ width: 80, flexShrink: 0 }}>Rate (₹)</Typography>
            <Typography variant="caption" color="text.secondary" sx={{ flex: 1, minWidth: 140 }}>Link Material</Typography>
            <Box sx={{ width: 36, flexShrink: 0 }} />
          </Box>
          {/* Item rows */}
          {bomFormRows.map((row, idx) => (
            <Box key={idx} sx={{ display: 'flex', gap: 1, mb: 1, alignItems: 'center' }}>
              <TextField
                size="small"
                sx={{ width: 180, flexShrink: 0 }}
                value={row.material_name}
                onChange={(e) => updateBomRow(idx, 'material_name', e.target.value)}
                placeholder="e.g. Top Fabric"
              />
              <TextField
                select
                size="small"
                sx={{ width: 120, flexShrink: 0 }}
                value={row.material_type}
                onChange={(e) => updateBomRow(idx, 'material_type', e.target.value)}
              >
                {BOM_MATERIAL_TYPES.map((t) => <MenuItem key={t} value={t}>{t}</MenuItem>)}
              </TextField>
              <TextField
                select
                size="small"
                sx={{ width: 110, flexShrink: 0 }}
                value={row.garment_part}
                onChange={(e) => updateBomRow(idx, 'garment_part', e.target.value)}
              >
                {BOM_GARMENT_PARTS.map((p) => <MenuItem key={p} value={p}>{p}</MenuItem>)}
              </TextField>
              <TextField
                size="small"
                type="number"
                sx={{ width: 80, flexShrink: 0 }}
                value={row.consumption_per_piece}
                onChange={(e) => updateBomRow(idx, 'consumption_per_piece', Number(e.target.value) || 0)}
                inputProps={{ min: 0, step: 0.01 }}
              />
              <TextField
                select
                size="small"
                sx={{ width: 90, flexShrink: 0 }}
                value={row.uom}
                onChange={(e) => updateBomRow(idx, 'uom', e.target.value)}
              >
                {BOM_UOMS.map((u) => <MenuItem key={u} value={u}>{u}</MenuItem>)}
              </TextField>
              <TextField
                size="small"
                type="number"
                sx={{ width: 80, flexShrink: 0 }}
                value={row.wastage_pct}
                onChange={(e) => updateBomRow(idx, 'wastage_pct', Number(e.target.value) || 0)}
                inputProps={{ min: 0, max: 50, step: 0.5 }}
              />
              <TextField
                size="small"
                type="number"
                sx={{ width: 80, flexShrink: 0 }}
                value={row.estimated_rate || ''}
                onChange={(e) => updateBomRow(idx, 'estimated_rate', e.target.value ? Number(e.target.value) : null)}
                inputProps={{ min: 0, step: 0.5 }}
              />
              <Autocomplete
                size="small"
                sx={{ flex: 1, minWidth: 140 }}
                options={existingAllocations.filter((a: any) => a.material).map((a: any) => a.material)}
                getOptionLabel={(m: any) => `${m.material_code} (${m.available_qty} ${m.uom})`}
                value={existingAllocations.map((a: any) => a.material).find((m: any) => m && m.id === row.material_id) || null}
                onChange={(_, newValue: any) => updateBomRow(idx, 'material_id', newValue?.id || null)}
                isOptionEqualToValue={(opt: any, val: any) => opt.id === val.id}
                renderInput={(params) => <TextField {...params} placeholder="Search allocated material" />}
              />
              <Box sx={{ width: 36, flexShrink: 0, textAlign: 'center' }}>
                {!bomEditingItem && bomFormRows.length > 1 && (
                  <IconButton size="small" onClick={() => removeBomRow(idx)} color="error">
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                )}
              </Box>
            </Box>
          ))}
        </Box>
        {!bomEditingItem && (
          <Button size="small" startIcon={<AddIcon />} onClick={addBomRow} sx={{ mt: 0.5 }}>
            Add Another Item
          </Button>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setBomDialogOpen(false)} disabled={bomSaving}>Cancel</Button>
        <Button variant="contained" onClick={handleBomSave} disabled={bomSaving}>
          {bomSaving ? 'Saving...' : bomEditingItem ? 'Update' : `Save ${bomFormRows.filter(r => r.material_name.trim()).length} Item(s)`}
        </Button>
      </DialogActions>
    </Dialog>
    </>
  );
};

const DesignsPage: React.FC = () => {
  const { canAdd, canEdit, canDelete, canView } = usePermissions();
  const [designs, setDesigns] = useState<Design[]>([]);
  const [loading, setLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedDesignId, setSelectedDesignId] = useState<number | null>(null);
  const [duplicateData, setDuplicateData] = useState<Partial<Design> | null>(null);
  const [searchQuery, setSearchQuery] = useState<string>(() => {
    return localStorage.getItem('designsPage_searchQuery') || '';
  });

  // Persist search query to localStorage
  useEffect(() => {
    localStorage.setItem('designsPage_searchQuery', searchQuery);
  }, [searchQuery]);
  const [filteredDesigns, setFilteredDesigns] = useState<Design[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState<number | null>(null);
  // Pagination
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(40);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const sentinelRef = useRef<HTMLDivElement | null>(null);
  
  // Filter states - initialized from localStorage
  const [productTypeFilter, setProductTypeFilter] = useState<string>(() => {
    return localStorage.getItem('designsPage_productTypeFilter') || '';
  });
  const [statusFilter, setStatusFilter] = useState<string[]>(() => {
    const saved = localStorage.getItem('designsPage_statusFilter');
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch {
        return ['APPROVED', 'HOLD'];
      }
    }
    return ['APPROVED', 'HOLD']; // Default: Approved and Hold selected
  });
  const [dateFromFilter, setDateFromFilter] = useState<string>(() => {
    return localStorage.getItem('designsPage_dateFromFilter') || '';
  });
  const [dateToFilter, setDateToFilter] = useState<string>(() => {
    return localStorage.getItem('designsPage_dateToFilter') || '';
  });
  const [showWithCutting, setShowWithCutting] = useState<boolean>(() => {
    const saved = localStorage.getItem('designsPage_showWithCutting');
    return saved === 'true';
  });

  // Quick-filter toggles
  const [filterNoJobWork, setFilterNoJobWork] = useState<boolean>(false);
  const [filterNoMaterial, setFilterNoMaterial] = useState<boolean>(false);
  const [filterNoPO, setFilterNoPO] = useState<boolean>(false);

  // View mode: desktop defaults to card, persisted; mobile always card
  const [viewMode, setViewMode] = useState<'card' | 'table'>(() => {
    const saved = localStorage.getItem('designsViewMode') as 'card' | 'table' | null;
    return saved || 'card';
  });
  const handleViewModeChange = (_: React.MouseEvent<HTMLElement>, next: 'card' | 'table' | null) => {
    if (!next) return;
    setViewMode(next);
    localStorage.setItem('designsViewMode', next);
    // Clear bulk selection when switching views
    setSelectedDesignIds(new Set());
    setTablePage(0);
  };

  // Table sort
  const [sortField, setSortField] = useState<'design_no' | 'created_at' | 'bom_cost' | 'approval_status'>('created_at');
  const [sortDir, setSortDir] = useState<'asc' | 'desc'>('desc');
  const handleSort = (field: typeof sortField) => {
    if (sortField === field) {
      setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDir('asc');
    }
  };

  // Bulk selection
  const [selectedDesignIds, setSelectedDesignIds] = useState<Set<number>>(new Set());
  const [bulkStatus, setBulkStatus] = useState<string>('');
  const [bulkUpdating, setBulkUpdating] = useState(false);

  // Table-view pagination (client-side slice of filteredDesigns)
  const [tablePage, setTablePage] = useState<number>(0);         // 0-indexed
  const [tableRowsPerPage, setTableRowsPerPage] = useState<number>(100);

  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      setSelectedDesignIds(new Set(filteredDesigns.map(d => d.id)));
    } else {
      setSelectedDesignIds(new Set());
    }
  };

  const handleSelectDesign = (id: number, checked: boolean) => {
    setSelectedDesignIds(prev => {
      const next = new Set(prev);
      if (checked) next.add(id); else next.delete(id);
      return next;
    });
  };

  // Reset table page to 0 whenever the underlying filtered list changes
  // (filter toggles, search, status filter, etc.)
  useEffect(() => {
    setTablePage(0);
  }, [filteredDesigns.length]);

  const handleBulkStatusChange = async () => {
    if (!bulkStatus || selectedDesignIds.size === 0) return;
    setBulkUpdating(true);
    try {
      await Promise.all(
        Array.from(selectedDesignIds).map(id =>
          designApi.update(id, { approval_status: bulkStatus as any })
        )
      );
      setDesigns(prev => prev.map(d =>
        selectedDesignIds.has(d.id) ? { ...d, approval_status: bulkStatus as any } : d
      ));
      setSuccessMessage(`${selectedDesignIds.size} design(s) updated to ${bulkStatus}`);
      setSelectedDesignIds(new Set());
      setBulkStatus('');
    } catch (e) {
      setError('Failed to update some designs');
    } finally {
      setBulkUpdating(false);
    }
  };

  // Persist filters to localStorage
  useEffect(() => {
    localStorage.setItem('designsPage_productTypeFilter', productTypeFilter);
  }, [productTypeFilter]);
  useEffect(() => {
    localStorage.setItem('designsPage_statusFilter', JSON.stringify(statusFilter));
  }, [statusFilter]);
  useEffect(() => {
    localStorage.setItem('designsPage_dateFromFilter', dateFromFilter);
  }, [dateFromFilter]);
  useEffect(() => {
    localStorage.setItem('designsPage_dateToFilter', dateToFilter);
  }, [dateToFilter]);
  useEffect(() => {
    localStorage.setItem('designsPage_showWithCutting', String(showWithCutting));
  }, [showWithCutting]);
  
  // Design preview dialog state
  const [previewDialogOpen, setPreviewDialogOpen] = useState(false);
  const [selectedPreviewDesign, setSelectedPreviewDesign] = useState<Design | null>(null);
  
  // Design cutting data for preview dialog
  const [selectedPreviewTopDesign, setSelectedPreviewTopDesign] = useState<any>(null);
  const [selectedPreviewBottomDesign, setSelectedPreviewBottomDesign] = useState<any>(null);
  const [loadingCuttingData, setLoadingCuttingData] = useState(false);
  const [statusUpdating, setStatusUpdating] = useState<{ [id: number]: boolean }>({});

  // Chat drawer state (desktop only)
  const [chatDrawerOpen, setChatDrawerOpen] = useState(false);
  const [chatDesign, setChatDesign] = useState<{ id: number; design_no: string } | null>(null);

  const handleOpenChat = (design: { id: number; design_no: string }) => {
    if (isMobile) {
      navigate(`/designs/chat?designId=${design.id}&designNo=${encodeURIComponent(design.design_no)}`);
    } else {
      setChatDesign(design);
      setChatDrawerOpen(true);
    }
  };

  // Tab state for switching between designs list and material allocation
  const [tabValue, setTabValue] = useState(0);
  const [selectedDesignForMaterials, setSelectedDesignForMaterials] = useState<string | null>(null);
  
  
  const navigate = useNavigate();
  const [designSearchParams, setDesignSearchParams] = useSearchParams();
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));

  // Get unique product types from designs for filter dropdown
  const uniqueProductTypes = useMemo(() => {
    const types = new Set<string>();
    designs.forEach(d => {
      if (d.product_type) types.add(d.product_type);
    });
    return Array.from(types).sort();
  }, [designs]);

  // Product type display names mapping
  const productTypeLabels: Record<string, string> = {
    'TOP': 'Top',
    'KURTI': 'Kurti',
    'DRESS': 'Dress',
    'SUIT': 'Salwar Suit',
    'TOPBOTTOMSET': 'Top Bottom Set'
  };
  
  // Load designs from API (supports server-side search)
  const fetchDesigns = async (page = currentPage, append = false) => {
    setLoading(true);
    setError(null);
    try {
      const response = await instance.get<Design[]>(`/designs`, {
        params: { summary: 1, page, pageSize, withCount: 1, q: searchQuery || undefined }
      });
      const safeData = Array.isArray(response.data) ? response.data : [];
      const total = Number(response.headers['x-total-count'] || 0);
      setDesigns(prev => append ? [...prev, ...safeData] : safeData);
      // filteredDesigns is recomputed by effect below
      setTotalCount(total);
      setCurrentPage(page);
      // determine if more pages
      if (total > 0) {
        setHasMore(page * pageSize < total);
      } else {
        setHasMore(safeData.length === pageSize);
      }
    } catch (error: any) {
      console.error('Error fetching designs:', error);
      setError(error.response?.data?.error || 'Failed to fetch designs');
      setDesigns([]);
      setFilteredDesigns([]);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };

  // Initial and page-change data load, and re-run on search
  useEffect(() => {
    fetchDesigns(1, false);
    setCurrentPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSize, searchQuery]);

  // Infinite scroll observer
  useEffect(() => {
    const el = sentinelRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(entries => {
      const first = entries[0];
      if (first.isIntersecting && hasMore && !loading) {
        fetchDesigns(currentPage + 1, true);
      }
    }, { root: null, rootMargin: '400px', threshold: 0.01 });
    observer.observe(el);
    return () => observer.disconnect();
  }, [hasMore, loading, currentPage]);

  // Filter designs based on filters (search handled server-side)
  useEffect(() => {
    let filtered = designs;
    if (productTypeFilter) {
      filtered = filtered.filter(design => design.product_type === productTypeFilter);
    }
    if (statusFilter.length > 0) {
      filtered = filtered.filter(design => statusFilter.includes(design.approval_status || ''));
    }
    // Filter by cutting records - by default hide designs with cutting records
    if (!showWithCutting) {
      filtered = filtered.filter(design => !design.has_cutting);
    }
    if (dateFromFilter) {
      const fromDate = new Date(dateFromFilter);
      filtered = filtered.filter(design => new Date(design.created_at) >= fromDate);
    }
    if (dateToFilter) {
      const toDate = new Date(dateToFilter);
      toDate.setHours(23, 59, 59, 999);
      filtered = filtered.filter(design => new Date(design.created_at) <= toDate);
    }
    // Quick-filter toggles (client-side using summary flags)
    if (filterNoJobWork)  filtered = filtered.filter(design => !(design.jobWorks && design.jobWorks.length > 0));
    if (filterNoMaterial) filtered = filtered.filter(design => !design.has_material);
    if (filterNoPO)       filtered = filtered.filter(design => !(design.purchaseOrders && design.purchaseOrders.length > 0));
    filtered = filtered.slice().sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
    setFilteredDesigns(filtered);
  }, [designs, productTypeFilter, statusFilter, dateFromFilter, dateToFilter, showWithCutting, filterNoJobWork, filterNoMaterial, filterNoPO]);

  // Re-fetch from page 1 when server-side-compatible filters change.
  // We clear designs + re-fetch so the infinite scroll never appends stale pages on top.
  // NOTE: filterNoJobWork / filterNoMaterial / filterNoPO are pure client-side slices —
  // they must NOT be in this effect or infinite-scroll will append duplicates.
  useEffect(() => {
    setDesigns([]);
    setFilteredDesigns([]);
    setCurrentPage(1);
    setHasMore(true);
    fetchDesigns(1, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productTypeFilter, statusFilter, dateFromFilter, dateToFilter, showWithCutting]);

  // Handle URL params for search and auto-preview (e.g. from Job Works page)
  useEffect(() => {
    const searchParam = designSearchParams.get('search');
    const previewParam = designSearchParams.get('preview');
    if (searchParam) {
      setSearchQuery(searchParam);
      // Clear the URL params after applying
      const newParams = new URLSearchParams(designSearchParams);
      newParams.delete('search');
      newParams.delete('preview');
      setDesignSearchParams(newParams, { replace: true });
    }
    if (previewParam === 'true' && filteredDesigns.length > 0 && !previewDialogOpen) {
      // Auto-open preview for the first matching design
      handleOpenPreview(filteredDesigns[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [designSearchParams, filteredDesigns]);

  // Open dialog for creating or editing
  const handleOpenDialog = (id: number | null = null) => {
    setSelectedDesignId(id);
    setDuplicateData(null);
    setDialogOpen(true);
  };

  // Close dialog
  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedDesignId(null);
    setDuplicateData(null);
  };

  // Handle duplicate design - called from the form dialog
  const handleDuplicateDesign = (designData: Partial<Design>) => {
    // Close current dialog and re-open with duplicate data
    setDialogOpen(false);
    setSelectedDesignId(null);
    // Remove id and set design_no to empty for new design
    const { id, ...dataWithoutId } = designData as Design;
    // Shift Image 1 to Image 2 and clear Image 1 for new upload
    setDuplicateData({
      ...dataWithoutId,
      design_no: '', // Clear design number for user to enter new one
      image_url: null, // Clear main image for user to upload new one
      image2_url: dataWithoutId.image_url || dataWithoutId.image2_url || null, // Move Image 1 to Image 2
    });
    // Re-open dialog after state update
    setTimeout(() => {
      setDialogOpen(true);
    }, 100);
  };

  // Register the duplicate handler globally so the dialog can access it
  React.useEffect(() => {
    (window as any).__handleDuplicateDesign = handleDuplicateDesign;
    return () => {
      delete (window as any).__handleDuplicateDesign;
    };
  }, []);

  // Handle save success
  const handleSaveSuccess = () => {
    fetchDesigns();
    const message = duplicateData 
      ? 'Design duplicated successfully' 
      : (selectedDesignId ? 'Design updated successfully' : 'Design created successfully');
    setSuccessMessage(message);
    handleCloseDialog();
  };

  // Handle opening job work dialog
  const handleOpenJobWorkDialog = (design: Design) => {
    // Navigate to job work creation page with design pre-filled and return URL
    navigate(`/job-works/new?designNo=${design.design_no}&returnTo=/designs`);
  };


  // Handle delete confirmation
  const handleDeleteConfirm = async () => {
    if (!deleteId) return;
    
    try {
      await designApi.delete(deleteId);
      setSuccessMessage('Design deleted successfully');
      fetchDesigns();
    } catch (error: any) {
      console.error('Error deleting design:', error);
      setError(error.response?.data?.error || 'Failed to delete design. Check if it has associated cuttings.');
    } finally {
      setDeleteDialogOpen(false);
      setDeleteId(null);
    }
  };

  // Handle opening the design preview dialog
  const handleOpenPreview = async (design: Design) => {
    // Set minimal data immediately for faster UX
    setSelectedPreviewDesign(design);
    setSelectedPreviewTopDesign(null);
    setSelectedPreviewBottomDesign(null);
    setLoadingCuttingData(true);
    setPreviewDialogOpen(true);

    // Fetch full design details (summary list omits many fields used in preview)
    try {
      const full = await designApi.getById(design.id as unknown as number);
      if (full?.data) {
        setSelectedPreviewDesign(full.data as Design);
      }
    } catch (e) {
      // ignore; keep minimal
    }

    // Fetch design cutting data for TOP and BOTTOM
    try {
      const response = await api.get('/design-cutting');
      if (response.data && Array.isArray(response.data)) {
        const allCuttingData = response.data;
        
        // Find TOP and BOTTOM designs with the same design number
        const topDesign = allCuttingData.find((d: any) => 
          d.design_no === design.design_no && d.garment_part === 'TOP'
        );
        const bottomDesign = allCuttingData.find((d: any) => 
          d.design_no === design.design_no && d.garment_part === 'BOTTOM'
        );
        
        setSelectedPreviewTopDesign(topDesign);
        setSelectedPreviewBottomDesign(bottomDesign);
      }
    } catch (error) {
      console.error('Error fetching design cutting data:', error);
      // Continue showing dialog even if cutting data fails to load
    } finally {
      setLoadingCuttingData(false);
    }
  };

  // Handle closing the design preview dialog
  const handleClosePreview = () => {
    setPreviewDialogOpen(false);
    setSelectedPreviewDesign(null);
    setSelectedPreviewTopDesign(null);
    setSelectedPreviewBottomDesign(null);
    setLoadingCuttingData(false);
  };

  // Handle clicking on a design to view its materials
  const handleViewMaterials = (design: Design) => {
    setSelectedDesignForMaterials(design.design_no);
    setTabValue(1); // Switch to the Materials tab
  };

  // Handle tab change
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(Number(newValue));
  };

  const handleStatusChange = async (design: Design, newStatus: 'APPROVED' | 'REJECTED' | 'HOLD' | 'COMPLETE') => {
    try {
      setStatusUpdating(prev => ({ ...prev, [design.id]: true }));
      await designApi.update(design.id, { approval_status: newStatus });
      // Update designs state so filters recompute and UI reflects the change
      setDesigns(prev => prev.map(d => d.id === design.id ? { ...d, approval_status: newStatus } : d));
      setSuccessMessage('Design status updated');
    } catch (e) {
      setError('Failed to update design status');
    } finally {
      setStatusUpdating(prev => ({ ...prev, [design.id]: false }));
    }
  };

  // Track toggle disabled (hidden in UI) - reserved for future feature
  const handleTrackToggle = async (design: Design, next: boolean) => {};

  // Check if user has permission to view this page
  if (!canView('designs')) {
    return (
      <Container maxWidth="sm" sx={{ textAlign: 'center', mt: 10 }}>
        <Typography variant="h5" gutterBottom color="error">
          Access Denied
        </Typography>
        <Typography>
          You don't have permission to view this page. Please contact your administrator.
        </Typography>
      </Container>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="design management tabs">
          <Tab label="Design List" id="tab-0" aria-controls="tabpanel-0" />
          <Tab label="Material Allocation" id="tab-1" aria-controls="tabpanel-1" />
        </Tabs>
      </Box>
      
      {/* Designs List Tab */}
      {tabValue === 0 && (
        <Box role="tabpanel" id="tabpanel-0" aria-labelledby="tab-0">
          <Grid container spacing={2} sx={{ mb: 3, alignItems: 'center' }}>
            <Grid item xs={12} sm={4}>
              <Typography variant="h5">Design Management</Typography>
            </Grid>
            
            <Grid item xs={12} sm={5}>
              <TextField 
                fullWidth
                variant="outlined"
                placeholder="Search designs..."
                size="small"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            
            <Grid item xs={12} sm={3}>
              {canAdd('designs') && (
                <Button
                  variant="contained"
                  fullWidth
                  startIcon={<AddIcon />}
                  onClick={() => handleOpenDialog()}
                >
                  Add Design
                </Button>
              )}
            </Grid>
          </Grid>
          
          {/* Filter Controls */}
          <Grid container spacing={2} sx={{ mb: 3, alignItems: 'center' }}>
            <Grid item xs={12} sm={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Product Type</InputLabel>
                <Select
                  value={productTypeFilter}
                  label="Product Type"
                  onChange={(e) => setProductTypeFilter(e.target.value)}
                >
                  <MenuItem value="">All Product Types</MenuItem>
                  {uniqueProductTypes.map((type) => (
                    <MenuItem key={type} value={type}>
                      {productTypeLabels[type] || type}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12} sm={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Status</InputLabel>
                <Select
                  multiple
                  value={statusFilter}
                  label="Status"
                  onChange={(e) => setStatusFilter(e.target.value as string[])}
                  renderValue={(selected) => {
                    if (selected.length === 0) return 'All Status';
                    if (selected.length === 4) return 'All Status';
                    const labels: Record<string, string> = {
                      'APPROVED': 'Approved',
                      'REJECTED': 'Rejected', 
                      'HOLD': 'Hold',
                      'COMPLETE': 'Complete'
                    };
                    return selected.map(s => labels[s] || s).join(', ');
                  }}
                >
                  <MenuItem value="APPROVED">Approved</MenuItem>
                  <MenuItem value="REJECTED">Rejected</MenuItem>
                  <MenuItem value="HOLD">Hold</MenuItem>
                  <MenuItem value="COMPLETE">Complete</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="From Date"
                value={dateFromFilter}
                onChange={(e) => setDateFromFilter(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            
            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="To Date"
                value={dateToFilter}
                onChange={(e) => setDateToFilter(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          </Grid>
          
          {/* Quick-filter chips + Cutting toggle + Clear */}
          <Box sx={{ mb: 2, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1 }}>
            <Chip
              label="No Job Work"
              size="small"
              clickable
              color={filterNoJobWork ? 'warning' : 'default'}
              variant={filterNoJobWork ? 'filled' : 'outlined'}
              onClick={() => setFilterNoJobWork(v => !v)}
            />
            <Chip
              label="No Material Allocated"
              size="small"
              clickable
              color={filterNoMaterial ? 'warning' : 'default'}
              variant={filterNoMaterial ? 'filled' : 'outlined'}
              onClick={() => setFilterNoMaterial(v => !v)}
            />
            <Chip
              label="No PO Raised"
              size="small"
              clickable
              color={filterNoPO ? 'warning' : 'default'}
              variant={filterNoPO ? 'filled' : 'outlined'}
              onClick={() => setFilterNoPO(v => !v)}
            />
            <Box sx={{ borderLeft: '1px solid', borderColor: 'divider', pl: 1, ml: 0.5 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={showWithCutting}
                    onChange={(e) => setShowWithCutting(e.target.checked)}
                    size="small"
                  />
                }
                label={<Typography variant="body2">With cutting</Typography>}
                sx={{ mr: 0 }}
              />
            </Box>
            <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>
              {/* View mode toggle — desktop only */}
              {!isMobile && (
                <ToggleButtonGroup
                  value={viewMode}
                  exclusive
                  onChange={handleViewModeChange}
                  size="small"
                >
                  <ToggleButton value="card" aria-label="Card view">
                    <Tooltip title="Card view">
                      <ViewModuleIcon fontSize="small" />
                    </Tooltip>
                  </ToggleButton>
                  <ToggleButton value="table" aria-label="Table view">
                    <Tooltip title="Table view">
                      <ViewListIcon fontSize="small" />
                    </Tooltip>
                  </ToggleButton>
                </ToggleButtonGroup>
              )}
              <Button
                variant="outlined"
                size="small"
                onClick={() => {
                  setProductTypeFilter('');
                  setStatusFilter(['APPROVED', 'HOLD']);
                  setDateFromFilter('');
                  setDateToFilter('');
                  setSearchQuery('');
                  setShowWithCutting(false);
                  setFilterNoJobWork(false);
                  setFilterNoMaterial(false);
                  setFilterNoPO(false);
                }}
              >
                Clear All Filters
              </Button>
            </Box>
          </Box>
          
          {error && (
            <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>
              {error}
            </Alert>
          )}
          
          <Snackbar 
            open={Boolean(successMessage)}
            autoHideDuration={4000}
            onClose={() => setSuccessMessage(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          >
            <Alert severity="success" sx={{ width: '100%' }}>
              {successMessage}
            </Alert>
          </Snackbar>
          
          {/* ── MOBILE: always card view ── */}
          {isMobile && (
            <>
              <Grid container spacing={1}>
                {filteredDesigns.map((design) => (
                  <Grid item xs={6} key={design.id}>
                    <Card sx={{ borderRadius: 2, boxShadow: 1, overflow: 'hidden' }}>
                    <Box
                      sx={{
                        position: 'relative',
                        width: '100%',
                        paddingTop: '140%',
                        bgcolor: '#f8f8f8',
                        cursor: 'pointer'
                      }}
                      onClick={() => handleOpenPreview(design)}
                    >
                      {(design.cad_file_1 || design.cad_file_2 || design.cad_file_3 || design.cad_file_4) && (
                        <Box sx={{ position: 'absolute', top: 6, left: 6, bgcolor: 'success.main', color: 'white', px: 0.75, py: 0.25, borderRadius: 1, fontSize: '0.6rem', fontWeight: 700, letterSpacing: 0.5, zIndex: 1 }}>
                          CAD
                        </Box>
                      )}
                      {canDelete('designs') && (
                        <IconButton
                          size="small" color="error"
                          onClick={(e) => { e.stopPropagation(); setDeleteDialogOpen(true); setDeleteId(design.id); }}
                          sx={{ position: 'absolute', top: 4, right: 4, bgcolor: 'rgba(255,255,255,0.9)', zIndex: 1, '&:hover': { bgcolor: 'rgba(255,255,255,1)' } }}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      )}
                      {design.image_url ? (
                        <img src={design.image_url} alt={design.design_no || ''} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'contain' }} />
                      ) : (
                        <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <Avatar variant="rounded" sx={{ width: 50, height: 75 }}>{design.design_no?.charAt(0)}</Avatar>
                        </Box>
                      )}
                    </Box>
                    <Box sx={{ p: 1 }}>
                      <Typography variant="subtitle2" fontWeight={600} noWrap>{design.design_no}</Typography>
                      <Typography variant="caption" color="text.secondary" noWrap>{design.product_type || '-'}</Typography>
                      <FormControl size="small" fullWidth sx={{ mt: 0.5 }}>
                        <Select value={design.approval_status || 'HOLD'} onChange={(e) => handleStatusChange(design, e.target.value as any)} disabled={!!statusUpdating[design.id]} sx={{ fontSize: '0.75rem' }}>
                          <MenuItem value="APPROVED">Approved</MenuItem>
                          <MenuItem value="REJECTED">Rejected</MenuItem>
                          <MenuItem value="HOLD">Hold</MenuItem>
                          <MenuItem value="COMPLETE">Complete</MenuItem>
                        </Select>
                      </FormControl>
                      <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
                        {canAdd('job-works') && (
                          <Button size="small" color="primary" onClick={() => handleOpenJobWorkDialog(design)} startIcon={<WorkIcon sx={{ fontSize: '0.9rem !important' }} />} sx={{ fontSize: '0.65rem', px: 0.5, minWidth: 0, textTransform: 'none' }}>
                            Issue Job
                          </Button>
                        )}
                        {canEdit('designs') && (
                          <IconButton size="small" onClick={() => handleOpenDialog(design.id)} color="primary">
                            <EditIcon fontSize="small" />
                          </IconButton>
                        )}
                      </Box>
                    </Box>
                    </Card>
                  </Grid>
                ))}
              </Grid>
              <Box ref={sentinelRef} sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                {loading && <CircularProgress size={24} />}
              </Box>
            </>
          )}

          {/* ── DESKTOP CARD VIEW ── */}
          {!isMobile && viewMode === 'card' && (
            <Paper elevation={2} sx={{ width: '100%', p: 2 }}>
              <Box sx={{ pr: 1 }}>
                <Grid container spacing={1.5}>
                  {filteredDesigns.map((design) => (
                    <Grid item key={design.id} xs={6} sm={4} md={3} lg={2} xl={2}>
                      <Card sx={{ borderRadius: 2, boxShadow: 1, height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <Box
                          sx={{ position: 'relative', width: '100%', paddingTop: '140%', bgcolor: '#f8f8f8', overflow: 'hidden', cursor: 'pointer' }}
                          onClick={() => handleOpenPreview(design)}
                        >
                          {design.image_url ? (
                            <img src={design.image_url} alt={design.design_no || ''} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'contain' }} />
                          ) : (
                            <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              <Avatar variant="rounded" sx={{ width: 60, height: 90 }}>{design.design_no?.charAt(0)}</Avatar>
                            </Box>
                          )}
                          {(design.cad_file_1 || design.cad_file_2 || design.cad_file_3 || design.cad_file_4) && (
                            <Box sx={{ position: 'absolute', top: 8, left: 8, bgcolor: 'success.main', color: 'white', px: 1, py: 0.25, borderRadius: 1, fontSize: '0.7rem', fontWeight: 700, letterSpacing: 0.5 }}>
                              CAD
                            </Box>
                          )}
                        </Box>
                        <CardContent sx={{ pb: 1 }}>
                          <Typography variant="subtitle1" fontWeight={700} noWrap>{design.design_no}</Typography>
                          <Typography variant="body2" color="text.secondary" noWrap>{design.product_type || '-'}</Typography>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                            <Typography variant="caption" color="text.secondary">
                              {design.created_at ? new Date(design.created_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '-'}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              {design.bom_cost != null ? `₹${Number(design.bom_cost).toFixed(2)}` : ''}
                            </Typography>
                          </Box>
                          <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <FormControl size="small" fullWidth>
                              <InputLabel>Status</InputLabel>
                              <Select label="Status" value={design.approval_status || 'HOLD'} onChange={(e) => handleStatusChange(design, e.target.value as any)} disabled={!!statusUpdating[design.id]}>
                                <MenuItem value="APPROVED">Approved</MenuItem>
                                <MenuItem value="REJECTED">Rejected</MenuItem>
                                <MenuItem value="HOLD">Hold</MenuItem>
                                <MenuItem value="COMPLETE">Complete</MenuItem>
                              </Select>
                            </FormControl>
                          </Box>
                        </CardContent>
                        <CardActions sx={{ justifyContent: 'flex-end', pt: 0, mt: 'auto', flexWrap: 'wrap', gap: 0.5 }}>
                          <IconButton size="small" color="primary" onClick={() => handleOpenChat({ id: design.id, design_no: design.design_no })} title="Discussion">
                            <ChatBubbleOutlineIcon fontSize="small" />
                          </IconButton>
                          {canAdd('job-works') && (
                            <Button size="small" color="primary" onClick={() => handleOpenJobWorkDialog(design)} startIcon={<WorkIcon />} sx={{ fontSize: '0.75rem' }}>
                              Issue Job
                            </Button>
                          )}
                          {canAdd('purchase-orders') && (
                            <Tooltip title="Raise Purchase Order">
                              <IconButton
                                size="small"
                                color="success"
                                onClick={() => navigate(`/purchase-orders?new=1&design_no=${encodeURIComponent(design.design_no)}`)}
                              >
                                <AddShoppingCartIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}
                          {canEdit('designs') && (
                            <Button size="small" onClick={() => handleOpenDialog(design.id)} startIcon={<EditIcon />}>Edit</Button>
                          )}
                        </CardActions>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Box>
              <Box ref={sentinelRef} sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                {loading && <CircularProgress size={24} />}
              </Box>
            </Paper>
          )}

          {/* ── DESKTOP TABLE VIEW ── */}
          {!isMobile && viewMode === 'table' && (() => {
            // Sort filteredDesigns in table view
            const statusOrder: Record<string, number> = { APPROVED: 0, HOLD: 1, COMPLETE: 2, REJECTED: 3 };
            const sorted = [...filteredDesigns].sort((a, b) => {
              let cmp = 0;
              if (sortField === 'design_no') cmp = (a.design_no || '').localeCompare(b.design_no || '');
              else if (sortField === 'created_at') cmp = new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
              else if (sortField === 'bom_cost') cmp = (Number(a.bom_cost) || 0) - (Number(b.bom_cost) || 0);
              else if (sortField === 'approval_status') cmp = (statusOrder[a.approval_status || ''] ?? 9) - (statusOrder[b.approval_status || ''] ?? 9);
              return sortDir === 'asc' ? cmp : -cmp;
            });

            // Client-side pagination slice
            const tableTotal = sorted.length;
            const safeTablePage = Math.min(tablePage, Math.max(0, Math.ceil(tableTotal / tableRowsPerPage) - 1));
            const pageStart = safeTablePage * tableRowsPerPage;
            const pageRows = sorted.slice(pageStart, pageStart + tableRowsPerPage);

            const allSelected = pageRows.length > 0 && pageRows.every(d => selectedDesignIds.has(d.id));
            const someSelected = pageRows.some(d => selectedDesignIds.has(d.id));
            const statusColor: Record<string, 'success' | 'warning' | 'error' | 'default'> = {
              APPROVED: 'success', HOLD: 'warning', REJECTED: 'error', COMPLETE: 'default'
            };
            const totalTablePages = Math.max(1, Math.ceil(tableTotal / tableRowsPerPage));

            return (
              <Paper elevation={2} sx={{ width: '100%' }}>
                {/* Bulk action bar */}
                {someSelected && (
                  <Box sx={{ px: 2, py: 1.5, display: 'flex', alignItems: 'center', gap: 2, bgcolor: 'primary.50', borderBottom: '1px solid', borderColor: 'divider', flexWrap: 'wrap' }}>
                    <Typography variant="body2" fontWeight={600} color="primary.main">
                      {selectedDesignIds.size} selected
                    </Typography>
                    <FormControl size="small" sx={{ minWidth: 160 }}>
                      <InputLabel>Change Status To</InputLabel>
                      <Select label="Change Status To" value={bulkStatus} onChange={e => setBulkStatus(e.target.value)}>
                        <MenuItem value="APPROVED">Approved</MenuItem>
                        <MenuItem value="HOLD">Hold</MenuItem>
                        <MenuItem value="REJECTED">Rejected</MenuItem>
                        <MenuItem value="COMPLETE">Complete</MenuItem>
                      </Select>
                    </FormControl>
                    <Button
                      variant="contained"
                      size="small"
                      disabled={!bulkStatus || bulkUpdating}
                      onClick={handleBulkStatusChange}
                    >
                      {bulkUpdating ? <CircularProgress size={16} /> : 'Apply'}
                    </Button>
                    {canAdd('purchase-orders') && (
                      <Button
                        variant="outlined"
                        size="small"
                        color="success"
                        startIcon={<AddShoppingCartIcon />}
                        onClick={() => {
                          const selectedDesignNos = filteredDesigns
                            .filter(d => selectedDesignIds.has(d.id))
                            .map(d => d.design_no);
                          navigate(`/purchase-orders?new=1&design_nos=${encodeURIComponent(selectedDesignNos.join(','))}`);
                        }}
                      >
                        Raise PO ({selectedDesignIds.size})
                      </Button>
                    )}
                    <Button size="small" onClick={() => { setSelectedDesignIds(new Set()); setBulkStatus(''); }}>
                      Clear Selection
                    </Button>
                  </Box>
                )}
                <TableContainer>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell padding="checkbox" sx={{ width: 48 }}>
                          <Checkbox
                            size="small"
                            indeterminate={someSelected && !allSelected}
                            checked={allSelected}
                            onChange={e => handleSelectAll(e.target.checked)}
                          />
                        </TableCell>
                        {/* Serial number column */}
                        <TableCell sx={{ width: 48, color: 'text.secondary', fontWeight: 600 }}>#</TableCell>
                        <TableCell sx={{ width: 64 }}>Image</TableCell>
                        <TableCell sortDirection={sortField === 'design_no' ? sortDir : false}>
                          <TableSortLabel active={sortField === 'design_no'} direction={sortField === 'design_no' ? sortDir : 'asc'} onClick={() => handleSort('design_no')}>
                            Design
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sortDirection={sortField === 'approval_status' ? sortDir : false}>
                          <TableSortLabel active={sortField === 'approval_status'} direction={sortField === 'approval_status' ? sortDir : 'asc'} onClick={() => handleSort('approval_status')}>
                            Status
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sortDirection={sortField === 'bom_cost' ? sortDir : false} align="right">
                          <TableSortLabel active={sortField === 'bom_cost'} direction={sortField === 'bom_cost' ? sortDir : 'asc'} onClick={() => handleSort('bom_cost')}>
                            Cost
                          </TableSortLabel>
                        </TableCell>
                        <TableCell>Info</TableCell>
                        <TableCell sx={{ width: 240 }}>Job Works</TableCell>
                        <TableCell sx={{ width: 220 }}>Production Orders</TableCell>
                        <TableCell align="right">Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {pageRows.map((design, idx) => (
                        <TableRow
                          key={design.id}
                          hover
                          selected={selectedDesignIds.has(design.id)}
                          sx={{ cursor: 'pointer' }}
                        >
                          <TableCell padding="checkbox" onClick={e => e.stopPropagation()}>
                            <Checkbox
                              size="small"
                              checked={selectedDesignIds.has(design.id)}
                              onChange={e => handleSelectDesign(design.id, e.target.checked)}
                            />
                          </TableCell>
                          {/* Serial number */}
                          <TableCell sx={{ color: 'text.secondary', fontSize: '0.78rem' }}>
                            {pageStart + idx + 1}
                          </TableCell>
                          <TableCell onClick={() => handleOpenPreview(design)} sx={{ py: 0.5 }}>
                            {design.image_url ? (
                              <Box sx={{ width: 40, height: 56, borderRadius: 1, overflow: 'hidden', bgcolor: '#f8f8f8' }}>
                                <img src={design.image_url} alt={design.design_no} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                              </Box>
                            ) : (
                              <Avatar variant="rounded" sx={{ width: 40, height: 56, fontSize: '1rem' }}>
                                {design.design_no?.charAt(0)}
                              </Avatar>
                            )}
                          </TableCell>
                          <TableCell onClick={() => handleOpenPreview(design)}>
                            <Typography variant="body2" fontWeight={600}>{design.design_no}</Typography>
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.3 }}>
                              {[
                                productTypeLabels[design.product_type || ''] || design.product_type,
                                design.name,
                                design.created_at ? new Date(design.created_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' }) : null
                              ].filter(Boolean).join(' · ')}
                            </Typography>
                          </TableCell>
                          <TableCell onClick={e => e.stopPropagation()}>
                            {canEdit('designs') ? (
                              <FormControl size="small" sx={{ minWidth: 120 }}>
                                <Select
                                  value={design.approval_status || 'HOLD'}
                                  onChange={e => handleStatusChange(design, e.target.value as any)}
                                  disabled={!!statusUpdating[design.id]}
                                  sx={{ fontSize: '0.8rem' }}
                                >
                                  <MenuItem value="APPROVED">Approved</MenuItem>
                                  <MenuItem value="REJECTED">Rejected</MenuItem>
                                  <MenuItem value="HOLD">Hold</MenuItem>
                                  <MenuItem value="COMPLETE">Complete</MenuItem>
                                </Select>
                              </FormControl>
                            ) : (
                              <Chip size="small" label={design.approval_status || 'HOLD'} color={statusColor[design.approval_status || ''] || 'default'} />
                            )}
                          </TableCell>
                          <TableCell align="right" onClick={() => handleOpenPreview(design)}>
                            <Typography variant="body2">
                              {design.bom_cost != null ? `₹${Number(design.bom_cost).toFixed(0)}` : '-'}
                            </Typography>
                          </TableCell>
                          <TableCell onClick={() => handleOpenPreview(design)}>
                            <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                              {design.has_cad && (
                                <Chip label="CAD" size="small" color="success" variant="outlined" sx={{ height: 20, fontSize: '0.65rem' }} />
                              )}
                              {design.has_material && (
                                <Chip label="Mat" size="small" color="info" variant="outlined" sx={{ height: 20, fontSize: '0.65rem' }} />
                              )}
                            </Box>
                          </TableCell>
                          {/* Job Works detail column */}
                          <TableCell>
                            {design.jobWorks && design.jobWorks.length > 0 ? (
                              <Stack spacing={0.5}>
                                {design.jobWorks.map((jw: any) => (
                                  <Tooltip key={jw.id} title={`${jw.code} · ${jw.status}`} arrow>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center', p: 0.5, borderRadius: 1, bgcolor: 'action.hover' }}>
                                      <Chip label={jw.vendor} size="small" color="primary" sx={{ maxWidth: 100, '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis' } }} />
                                      <Chip label={jw.jobType} size="small" variant="outlined" sx={{ fontSize: '0.65rem', height: 20 }} />
                                      {jw.qty > 0 && <Chip label={`${jw.qty} pcs`} size="small" color="info" variant="outlined" sx={{ fontSize: '0.65rem', height: 20 }} />}
                                      <Chip
                                        label={`${jw.agingDays}d`}
                                        size="small"
                                        sx={{ fontSize: '0.65rem', height: 20, bgcolor: jw.agingDays > 14 ? 'error.light' : jw.agingDays > 7 ? 'warning.light' : 'success.light', color: 'white' }}
                                      />
                                    </Box>
                                  </Tooltip>
                                ))}
                              </Stack>
                            ) : (
                              <Typography variant="caption" color="text.disabled">-</Typography>
                            )}
                          </TableCell>
                          {/* Purchase Orders detail column */}
                          <TableCell>
                            {design.purchaseOrders && design.purchaseOrders.length > 0 ? (
                              <Stack spacing={0.5}>
                                {design.purchaseOrders.map((po: any) => (
                                  <Tooltip key={po.id} title={`${po.poNumber} · ${po.status}`} arrow>
                                    <Box
                                      sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center', p: 0.5, borderRadius: 1, bgcolor: 'action.hover', cursor: 'pointer' }}
                                      onClick={() => navigate(`/purchase-orders?po=${po.poNumber}`)}
                                    >
                                      <Chip label={po.poNumber} size="small" color="secondary" variant="outlined" sx={{ fontWeight: 700, fontSize: '0.65rem', height: 20 }} />
                                      <Chip label={po.vendor} size="small" color="primary" sx={{ maxWidth: 100, fontSize: '0.65rem', height: 20, '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis' } }} />
                                      {po.totalQty > 0 && <Chip label={`Qty ${po.totalQty}`} size="small" color="info" variant="outlined" sx={{ fontSize: '0.65rem', height: 20 }} />}
                                    </Box>
                                  </Tooltip>
                                ))}
                              </Stack>
                            ) : (
                              <Typography variant="caption" color="text.disabled">-</Typography>
                            )}
                          </TableCell>
                          <TableCell align="right" onClick={e => e.stopPropagation()}>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 0.5 }}>
                              <Tooltip title="Discussion">
                                <IconButton size="small" color="primary" onClick={() => handleOpenChat({ id: design.id, design_no: design.design_no })}>
                                  <ChatBubbleOutlineIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              {canAdd('job-works') && (
                                <Tooltip title="Issue Job Work">
                                  <IconButton size="small" color="primary" onClick={() => handleOpenJobWorkDialog(design)}>
                                    <WorkIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              )}
                              {canAdd('purchase-orders') && (
                                <Tooltip title="Raise Purchase Order">
                                  <IconButton
                                    size="small"
                                    color="success"
                                    onClick={() => navigate(`/purchase-orders?new=1&design_no=${encodeURIComponent(design.design_no)}`)}
                                  >
                                    <AddShoppingCartIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              )}
                              {canEdit('designs') && (
                                <Tooltip title="Edit">
                                  <IconButton size="small" onClick={() => handleOpenDialog(design.id)}>
                                    <EditIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              )}
                              {canDelete('designs') && (
                                <Tooltip title="Delete">
                                  <IconButton size="small" color="error" onClick={() => { setDeleteDialogOpen(true); setDeleteId(design.id); }}>
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                      {pageRows.length === 0 && !loading && (
                        <TableRow>
                          <TableCell colSpan={10} align="center" sx={{ py: 4 }}>
                            <Typography color="text.secondary">No designs found</Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* Pagination footer */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, borderTop: '1px solid', borderColor: 'divider', flexWrap: 'wrap', gap: 1 }}>
                  {/* Left: total count + rows-per-page selector */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Typography variant="body2" color="text.secondary">
                      {tableTotal === 0
                        ? 'No designs'
                        : `${pageStart + 1}–${Math.min(pageStart + tableRowsPerPage, tableTotal)} of ${tableTotal}`}
                    </Typography>
                    <FormControl size="small" sx={{ minWidth: 90 }}>
                      <Select
                        value={tableRowsPerPage}
                        onChange={e => { setTableRowsPerPage(Number(e.target.value)); setTablePage(0); }}
                        sx={{ fontSize: '0.8rem' }}
                      >
                        {[25, 50, 100, 200].map(n => (
                          <MenuItem key={n} value={n}>{n} / page</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>

                  {/* Right: prev / page numbers / next */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Tooltip title="Previous page">
                      <span>
                        <IconButton size="small" onClick={() => setTablePage(p => Math.max(0, p - 1))} disabled={safeTablePage === 0}>
                          <Typography variant="body2" sx={{ px: 0.5 }}>‹</Typography>
                        </IconButton>
                      </span>
                    </Tooltip>
                    {/* Page number buttons — show up to 5 pages around current */}
                    {Array.from({ length: totalTablePages }, (_, i) => i)
                      .filter(i => i === 0 || i === totalTablePages - 1 || Math.abs(i - safeTablePage) <= 2)
                      .reduce<(number | 'ellipsis')[]>((acc, i, idx, arr) => {
                        if (idx > 0 && i - (arr[idx - 1] as number) > 1) acc.push('ellipsis');
                        acc.push(i);
                        return acc;
                      }, [])
                      .map((item, i) =>
                        item === 'ellipsis' ? (
                          <Typography key={`e-${i}`} variant="body2" sx={{ px: 0.5, color: 'text.disabled' }}>…</Typography>
                        ) : (
                          <Button
                            key={item}
                            size="small"
                            variant={item === safeTablePage ? 'contained' : 'text'}
                            onClick={() => setTablePage(item as number)}
                            sx={{ minWidth: 32, px: 0.5, py: 0.25, fontSize: '0.8rem' }}
                          >
                            {(item as number) + 1}
                          </Button>
                        )
                      )}
                    <Tooltip title="Next page">
                      <span>
                        <IconButton size="small" onClick={() => setTablePage(p => Math.min(totalTablePages - 1, p + 1))} disabled={safeTablePage >= totalTablePages - 1}>
                          <Typography variant="body2" sx={{ px: 0.5 }}>›</Typography>
                        </IconButton>
                      </span>
                    </Tooltip>
                  </Box>
                </Box>

                {/* Sentinel still needed so infinite-scroll can load more data while paginating */}
                <Box ref={sentinelRef} sx={{ height: 1 }} />
                {loading && <Box sx={{ display: 'flex', justifyContent: 'center', py: 1 }}><CircularProgress size={20} /></Box>}
              </Paper>
            );
          })()}
          
        </Box>
      )}
      
      {tabValue === 1 && (
        <Box role="tabpanel" id="tabpanel-1" aria-labelledby="tab-1">
          <DesignMaterialContent selectedDesignNo={selectedDesignForMaterials} />
        </Box>
      )}

      {/* ── Shared dialogs — rendered outside all tab panels so they work on any tab ── */}
      {dialogOpen && (
        <DesignFormDialog
          open={dialogOpen}
          designId={duplicateData ? null : selectedDesignId}
          onClose={handleCloseDialog}
          onSave={handleSaveSuccess}
          onDelete={(id) => { setDeleteDialogOpen(true); setDeleteId(id); }}
          initialDuplicateData={duplicateData}
        />
      )}

      <DesignPreviewDialog
        open={previewDialogOpen}
        design={selectedPreviewDesign}
        designNo={selectedPreviewDesign?.design_no}
        topDesign={selectedPreviewTopDesign}
        bottomDesign={selectedPreviewBottomDesign}
        loadingCuttingData={loadingCuttingData}
        onClose={handleClosePreview}
      />

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete this design?
            This action cannot be undone.
          </Typography>
          <Typography variant="caption" color="error" sx={{ display: 'block', mt: 1 }}>
            Note: Designs with associated cutting records cannot be deleted.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleDeleteConfirm} color="error" variant="contained">Delete</Button>
        </DialogActions>
      </Dialog>

      {/* Chat Drawer (desktop only) */}
      {!isMobile && (
        <Drawer
          anchor="right"
          open={chatDrawerOpen}
          onClose={() => setChatDrawerOpen(false)}
          PaperProps={{ sx: { width: 400 } }}
        >
          {chatDesign && (
            <Box sx={{ position: 'relative', height: '100%' }}>
              <DesignChatThread designId={chatDesign.id} designNo={chatDesign.design_no} />
            </Box>
          )}
        </Drawer>
      )}
    </Box>
  );
};

export default DesignsPage; 